import { EcgListItem } from './ecg-list-item.model';

export class EcgList extends Array<EcgListItem> {}
